// extracted by mini-css-extract-plugin
export default {"darkmode":"Root_darkmode__oxU2Q","lightmode":"Root_lightmode__eEdmW"};